import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Multiple"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-multiple',
    templateUrl: './icon-cash-multiple.component.html',
    styleUrls: ['./icon-cash-multiple.component.scss'],
    standalone: false
})
export class IconCashMultipleComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
